export default __webpack_public_path__ + "static/media/bol_1.63e8b091.svg";